import React, { useEffect, useState } from "react";
import api from "utils/apiService";

import TableDemo from "components/TableDemo";
import RequetsColumn from "data/RequetsColumn";
import { useSearchParams } from "react-router-dom";

const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";

  const fetchData = async () => {
    try {
      const res = await api.get(`/users/requestingContractors?page=${page}${search && `&name=${search}`}`);

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, search]);
  return (
    <section className="mt-3">
      <TableDemo
        data={data?.data}
        columns={RequetsColumn(fetchData)}
        title="طلبات التسجيل"
        totalCount={data?.pagination?.totalDocs}
        loading={loading}
        searchExtra='name'
      />
    </section>
  );
};

export default Index;
